// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { baseUrl } from './../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getCommonTopicList = createAsyncThunk(
  'commontopic/commonTopics',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseUrl()}/commonTopics`, { params })

      return {
        totalPages: response?.data?.count?.total ?? 0,
        commonTopicList: response?.data?.data ?? [],
        filterParams: params
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

export const getCommonTopicById = createAsyncThunk(
  'commontopic/getCommonTopicById',
  async ({ topicId }) => {
    const response = await axios.get(baseUrl() + `/commonTopics/${topicId}`)
    return {
      topicById: response?.data?.data
    }
  }
)

export const getCommonTopicListByTopicStatus = createAsyncThunk(
  'commontopic/getCommonTopicListByTopicStatus',
  async ({ id, userId, status }) => {
    let topics = []
    let url =
      baseUrl() +
      `/commonTopics?export=false&technologyId=${id}&userId=${userId}&topicStatus=${status}`
    await axios
      .get(url)
      .then((res) => {
        topics = [...res?.data]
      })
      .catch((e) => {
        console.log('error while fetching status wise topics', e)
        return {
          alltopicList: []
        }
      })
    return {
      alltopicList: [...topics] || []
    }
  }
)

export const addTopic = createAsyncThunk(
  'commontopic/addTopic',
  async ({ formData, params }, { dispatch }) => {
    try {
      const res = await axios.post(baseUrl() + '/commonTopics', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      toast.success(res?.data?.message)
      await dispatch(getCommonTopicList(params))
      return true
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return false
    } finally {
      dispatch(setLoading(false))
    }
  }
)

export const updateTopic = createAsyncThunk(
  'commontopic/updateTopic',
  async ({ id, formData, params }, { dispatch }) => {
    try {
      const res = await axios.put(baseUrl() + `/commonTopics/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      toast.success(res?.data?.message)
      await dispatch(getCommonTopicList(params))
      return { id }
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return false
    } finally {
      dispatch(setLoading(false))
    }
  }
)

export const deleteCommonTopic = createAsyncThunk(
  'commontopic/deleteTopic',
  async ({ id, pageNo, pageSize, search, params }, { dispatch }) => {
    try {
      dispatch(setLoader())
      const res = await axios.delete(baseUrl() + '/commonTopics/' + id)
      toast.success(res?.data?.message)
      await dispatch(
        getCommonTopicList({
          pageNo,
          pageSize,
          search,
          ...params
        })
      )
      return id
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
)

export const commontopicSlice = createSlice({
  name: 'commontopic',
  initialState: {
    commonTopicList: [],
    alltopicList: [],
    topicById: [],
    AllCommonTopicList: [],
    selected: null,
    loader: true,
    loading: false,
    currentPage: 1,
    rowsPerPage: 25,
    totalPages: 0,
    clearFilter: false,
    filterParams: {},
    filterData: null
  },
  reducers: {
    selectTopic: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    },
    setFilterData: (state, action) => {
      if (action.payload === null) {
        state.filterData = null
      } else {
        state.filterData = action.payload
      }
    },
    setLoader: (state, action) => {
      state.loader = action.payload
    },
    selectCurrentPage: (state, action) => {
      if (action.payload === null) {
        state.currentPage = null
      } else {
        state.currentPage = action.payload
      }
    },
    selectRowsPerPage: (state, action) => {
      if (action.payload === null) {
        state.rowsPerPage = null
      } else {
        state.rowsPerPage = action.payload
      }
    },
    selectClearFilter: (state, action) => {
      state.clearFilter = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCommonTopicList.fulfilled, (state, action) => {
        ;((state.commonTopicList = action.payload.commonTopicList),
          (state.totalPages = action.payload.totalPages))
        state.filterParams = action?.payload?.filterParams
        state.loader = false
      })
      .addCase(getCommonTopicList.rejected, (state, action) => {
        ;((state.commonTopicList = []), (state.totalPages = 0))
        state.filterParams = action?.payload?.filterParams
        state.loader = false
      })
      .addCase(getCommonTopicList.pending, (state) => {
        state.loader = true
      })
      .addCase(getCommonTopicById.fulfilled, (state, action) => {
        state.topicById = action.payload.topicById
      })
  }
})

export const {
  selectTopic,
  setLoader,
  selectClearFilter,
  selectCurrentPage,
  selectRowsPerPage,
  setLoading,
  setFilterData
} = commontopicSlice.actions

export default commontopicSlice.reducer
